module.exports = __webpack_public_path__ + "img/specials-multislider.a286e733.png";